import { DeletionInfo, Meta, RemoveUserRequest } from "entities/common";
import { UserItem } from "entities/companies";
import { DELETE, GET } from "utils/http";

const baseUrl = "/api/users";

export const getList = (query = "") => GET<{ items: UserItem[] } & Meta>(`${baseUrl}${query}`);

export const remove = (data: { userId: number; body: RemoveUserRequest }) =>
  DELETE(`${baseUrl}/${data.userId}`, {
    data: data.body,
    headers: {
      "Content-Type": "application/json",
    },
  });

export const getDeletionInfo = (userId: number) => GET<DeletionInfo>(`${baseUrl}/${userId}/deletion-info`);
